/**
 * "Delete this song?" confirmation.
 *
 * Copy is verbatim, including the straight quotes around the title and the
 * "This can't be undone." sentence.
 */
import { Trash2 } from 'lucide-react';
import ConfirmDialog from './ConfirmDialog';
import { c } from '../../styles/theme';
import type { Song } from '../../types/domain';
import type { DeleteSongSurface } from '../../stores/uiStore';

export interface DeleteSongModalProps {
  /** The song pending deletion, or null when closed. */
  song: Song | null;
  surface?: DeleteSongSurface;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteSongModal({
  song,
  surface = 'library',
  onClose,
  onConfirm,
}: DeleteSongModalProps) {
  const body =
    surface === 'generatedResult'
      ? `Delete "${song?.title}"? This removes it from your library.`
      : `"${song?.title}" will be permanently removed from your library. This can't be undone.`;

  return (
    <ConfirmDialog
      open={Boolean(song)}
      onClose={onClose}
      title="Delete this song?"
      icon={<Trash2 size={19} color={c.danger} />}
      destructive
      confirmLabel="Delete song"
      confirmIcon={<Trash2 size={13} />}
      onConfirm={onConfirm}
    >
      <p style={{ fontSize: 12, color: c.text2, margin: '0 0 18px', lineHeight: 1.5 }}>{body}</p>
    </ConfirmDialog>
  );
}
